import { Component, OnInit } from '@angular/core';
import {RegistryService} from "../../services/registry.service";
import {CustomerService} from "../../../admin/services/customer.service";

@Component({
  selector: 'app-text-ad',
  templateUrl: './text-ad.component.html',
  styleUrls: ['./text-ad.component.css']
})
export class TextAdComponent implements OnInit {

  lang = "ar";
  constructor(
      public customerService:CustomerService
  ) { }

  ngOnInit(): void {

    this.lang = this.customerService.getCurrentLang();
  }

}
